/**
 * Maps account `freePage` values (CRM / LeadOverview) to Start portal routes.
 * Account values often differ from React Router paths under /start/.
 */
const FREE_PAGE_ROUTE_ALIASES = {
  'sales-proposals': 'sales/proposals',
  'finance/labor-burden': 'finance/startlaborburden',
  'operations/org-chart': 'existing-org-chart',
  // Leads marketing page deleted July 2026 — send to the marketing hub.
  'marketing/leads-calculator': 'marketing'
};

/**
 * @param {string | null | undefined} freePage
 * @returns {string | null} Path segment after `/start/` (no leading slash)
 */
export function resolveStartFreePagePath(freePage) {
  if (!freePage || typeof freePage !== 'string') return null;
  const trimmed = freePage.trim().replace(/^\/+|\/+$/g, '');
  if (!trimmed) return null;
  return FREE_PAGE_ROUTE_ALIASES[trimmed] || trimmed;
}

/**
 * @param {string | null | undefined} freePage
 * @returns {string | null} Full path including `/start` prefix
 */
export function getStartFreePageUrl(freePage) {
  const path = resolveStartFreePagePath(freePage);
  return path ? `/start/${path}` : null;
}
